import React, { useState, useEffect } from "react";
import { deleteCreditCard } from "@actions/paymentMethods";
import { defaultAction } from "@actions/defaultAction";
import { REMOVE_CREDIT_CARD_MODAL_OPEN } from "@constants/actionTypes";
import styled from "@emotion/styled";
import CustomSubmitButton from "./CustomSubmitButton";
import { useDispatch, useSelector } from "react-redux";

const ButtonDiv = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  grid-gap: 25px;
  margin-top: 43px;

  @media (max-width: 600px) {
    margin-top: 30px;
  }
  @media (max-width: 550px) {
    width: 85%;
    margin: 0 auto;
    margin-top: 24px;
  }

  @media (max-width: 500px) {
    margin-bottom: 20px;
  }
`;

const CreditRemoveInner = () => {
  const dispatch = useDispatch();
  const creditCardToRemove = useSelector(
    state => state.customerInfo.creditCardToRemove
  );
  const open = useSelector(
    state => state.userActions.showRemoveCreditCardModal
  );

  const [removeText, setRemoveText] = useState("Remove");
  const [removeButton, setRemoveButton] = useState("ORANGE_BUTTON");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (open) {
      setLoading(false);
    }
  }, [open]);

  const removeCreditCard = async () => {
    if (loading) return;
    setLoading(true);
    const response = await dispatch(deleteCreditCard(creditCardToRemove));
    if (response === "success") {
      setRemoveText("Success");
      setRemoveButton("GREEN_BUTTON");
      setTimeout(() => {
        setRemoveText("Remove");
        setRemoveButton("ORANGE_BUTTON");
        dispatch(defaultAction(REMOVE_CREDIT_CARD_MODAL_OPEN, false));
      }, 1000);
    } else {
      setLoading(false);
    }
  };
  return (
    <div className="modal-content modal-content-padding">
      <div className="modal-header mar-t-5">
        <div className="acct-modal-close-btn">
          <img
            src="https://cdn.cardcash.com/website/ui/elements/close.svg"
            className="fa fa-times"
            aria-hidden="true"
            onClick={() =>
              dispatch(defaultAction(REMOVE_CREDIT_CARD_MODAL_OPEN, false))
            }
            alt="close button"
          />
        </div>
        <div className="acct-modal-heading">Remove Credit Card</div>
      </div>
      <div
        className="modal-body modal-body-padding"
        style={{ fontSize: "14px" }}
      >
        <div className="acct-modal-text">
          Are you sure you want to remove this credit card?
        </div>
        <div>
          <ButtonDiv>
            <CustomSubmitButton
              styles={{ height: "72px", borderRadius: "36px" }}
              action={() => {
                removeCreditCard();
              }}
              buttonType={removeButton}
              className={"remove-cc-modal-button"}
            >
              {removeText}
            </CustomSubmitButton>
            <CustomSubmitButton
              styles={{ height: "72px", borderRadius: "36px" }}
              action={() =>
                dispatch(defaultAction(REMOVE_CREDIT_CARD_MODAL_OPEN, false))
              }
              buttonType={"WHITE_BUTTON_ORANGE_COLOR"}
              className={"remove-cc-modal-button"}
            >
              Close
            </CustomSubmitButton>
          </ButtonDiv>
        </div>
      </div>
    </div>
  );
};

export default CreditRemoveInner;
